import { type Topic } from "@/mocks/topics";

const heatStyles: Record<string, string> = {
  高热: "bg-primary-500 text-background-50",
  升温: "bg-accent-500 text-accent-950",
  新收录: "bg-secondary-100 text-secondary-900",
};

export default function TopicCard({ topic }: { topic: Topic }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <div className="relative h-44 w-full overflow-hidden md:h-48">
        <img
          src={topic.image}
          alt={`${topic.title} 选题配图`}
          title={`${topic.title} - 爆料投稿高热度选题参考`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <span
          className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-[11px] font-semibold ${heatStyles[topic.heat]}`}
        >
          {topic.heat}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex flex-wrap items-center gap-2 text-[11px] text-foreground-500">
          <span className="rounded-full bg-background-100 px-2.5 py-1 text-foreground-600">{topic.category}</span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line text-sm leading-none"></i>
            {topic.deadline}
          </span>
        </div>

        <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
          {topic.title}
        </h3>
        <p className="mt-2.5 flex-1 text-sm leading-relaxed text-foreground-600">{topic.summary}</p>

        <div className="mt-4 rounded-md border border-dashed border-background-300 bg-background-100/60 p-3">
          <p className="text-[11px] font-medium tracking-wide text-primary-600">标题参考</p>
          <p className="mt-1 text-sm font-medium leading-snug text-foreground-800">{topic.sampleTitle}</p>
        </div>

        <div className="mt-4 flex flex-wrap gap-1.5">
          {topic.angles.map((angle) => (
            <span
              key={angle}
              className="rounded-full border border-secondary-200 bg-secondary-50 px-2.5 py-1 text-[11px] text-secondary-800"
            >
              {angle}
            </span>
          ))}
        </div>

        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3.5 text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-fire-line text-sm leading-none text-primary-500"></i>
            热度 {topic.heatScore}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-inbox-archive-line text-sm leading-none text-secondary-500"></i>
            已收 {topic.leads} 条线索
          </span>
        </div>
      </div>
    </article>
  );
}